import React, { Fragment, memo } from 'react';
import PropTypes from 'prop-types';
import { SmallText, Text, Row } from 'modules/styled';
import { computeShares } from 'app/utils/post';
import { PieChart } from 'modules/stats/piechart';
import { colors } from 'styles';
import { abbreviateNumber as toFixed } from 'utils/numbers';

BetStats.propTypes = {
  post: PropTypes.object,
  earning: PropTypes.object,
  amount: PropTypes.number,
  maxBet: PropTypes.number,
};

export default memo(BetStats);

function BetStats({ post, amount, earning, maxBet }) {
  const existingShares = earning?.shares || 0;
  const existingStake = earning?.stakedTokens || 0;
  const bets = post?.data?.bets || post?.data?.upVotes;
  const users = bets > 1 ? 'users' : 'user';
  const invText =
    bets && post?.data?.totalShares
      ? `${bets} ${users} bet a total of ${toFixed(
          post?.data?.totalShares || 0
        )} coins on this post`
      : 'You are the first to bet on this post. This means you win big if it becomes relevant!';

  const shares = computeShares({ post, stakedTokens: amount });
  // const postRewards = computePostPayout(post.data, community);
  const shareOfRewards = !bets
    ? (existingStake + amount) / (maxBet + existingStake)
    : (shares + existingShares) / (post.data.shares + shares);

  const shareOfRewardsPercent = shareOfRewards * 100;

  const shareEl = (
    <SmallText>
      {'  '}
      <Text sx={{ top: 2 }}>
        <PieChart
          w={'12px'}
          h={'12px'}
          percent={100 - shareOfRewardsPercent}
          strokeWidth={30}
          color={colors.blue}
        />
      </Text>{' '}
      {toFixed(shareOfRewardsPercent)}%
    </SmallText>
  );

  return (
    <Fragment>
      <SmallText>{invText}</SmallText>
      {post?.data?.totalShares ? (
        <Row sx={{ mt: 2.001, alignItems: 'baseline' }}>
          <SmallText>Your estimated share of post payout:</SmallText>
          <SmallText>{shareEl}</SmallText>
        </Row>
      ) : null}
    </Fragment>
  );
}
